import React, { useMemo, useState, useRef, useEffect } from 'react';
import { Box, Paper, Typography, CircularProgress, Alert } from '@mui/material';
import { API_BASE_URL } from '../../services/config';

const MauticManual = ({ campaignId = null }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const iframeRef = useRef(null);

  const baseUrl = API_BASE_URL || window.location.origin;
  
  // Extract campaign ID from path if editing
  const editCampaignId = campaignId;
  const isEditMode = !!editCampaignId;

  const src = useMemo(() => {
    if (isEditMode) {
      return `${baseUrl}/campaigns/mautic/proxy?path=/s/campaigns/edit/${encodeURIComponent(editCampaignId)}`;
    }
    return `${baseUrl}/campaigns/mautic/proxy?path=/s/campaigns/new`;
  }, [baseUrl, isEditMode, editCampaignId]);

  // Allow iframe to load - Mautic will naturally show its lock notification if needed
  useEffect(() => {
    // Set loading to false after a brief moment to allow iframe to start loading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const handleIframeLoad = () => {
    setIsLoading(false);
    setHasError(false);
    // Mautic will handle showing the lock notification naturally if needed
  };

  const handleIframeError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  return (
    <Box sx={{ p: 2, height: '85vh', display: 'flex', flexDirection: 'column' }}>
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {isEditMode ? 'Modification de campagne' : 'Création manuelle'}
        </Typography>
      </Paper>
      <Paper sx={{ overflow: 'hidden', flex: 1, display: 'flex', position: 'relative' }}>
        <Box sx={{ height: '100%', width: '100%', position: 'relative' }}>
          {isLoading && (
            <Box sx={{ 
              position: 'absolute', 
              top: 0, 
              left: 0, 
              right: 0, 
              bottom: 0, 
              display: 'flex', 
              flexDirection: 'column',
              alignItems: 'center', 
              justifyContent: 'center', 
              bgcolor: 'rgba(255, 255, 255, 0.9)',
              zIndex: 1
            }}>
              <CircularProgress size={40} sx={{ mb: 2 }} />
              <Typography variant="body2" color="text.secondary">
                Chargement de l'éditeur...
              </Typography>
            </Box>
          )}
          
          {hasError && (
            <Box sx={{ 
              position: 'absolute', 
              top: 0, 
              left: 0, 
              right: 0, 
              bottom: 0, 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              zIndex: 1
            }}>
              <Alert severity="error" sx={{ maxWidth: 400 }}>
                Erreur lors du chargement de l'éditeur. Veuillez réessayer.
              </Alert>
            </Box>
          )}
          
          <iframe
            ref={iframeRef}
            title={isEditMode ? "Mautic Edit Campaign" : "Mautic Create Campaign"}
            src={src}
            style={{ border: 'none', width: '100%', height: '100%' }}
            sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation"
            onLoad={handleIframeLoad}
            onError={handleIframeError}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default MauticManual;


